import { useSelector } from "react-redux";
import { SetupType } from "../../../models/features/Integration/DmsSetup";
import HighImpactSetting from "./HighImpactSetting";
import { AppState } from "../../../redux/reducer/rootReducer";
import { ShopifyInstallation } from "./ShopifyInstallation";
import BigCommerceSetting from "./BigCommerceSetting";
import WordPressSetting from "./WordPressSetting";

interface PlatformSettingProps {
  handleNext: any;
  handleBack?: any;
}
export const PlatformSetting: React.FunctionComponent<PlatformSettingProps> = ({
  handleNext,
  handleBack,
}) => {
  const setupType = useSelector(
    (state: AppState) => state.dmsReducer.setupType,
  );
  switch (setupType) {
    case SetupType.Shopify:
      return (
        <ShopifyInstallation handleBack={handleBack} handleNext={handleNext} />
      );
    case SetupType.BigCommerce:
      return (
        <BigCommerceSetting handleBack={handleBack} handleNext={handleNext} />
      );
    case SetupType.HiImpact:
      return (
        <HighImpactSetting handleBack={handleBack} handleNext={handleNext} />
      );
    case SetupType.WordPress:
      return (
        <WordPressSetting handleBack={handleBack} handleNext={handleNext} />
      );
    default:
      return <div>Please select a platform type</div>;
  }
};

export default PlatformSetting;
